module.exports = __webpack_public_path__ + "static/img/wxLogin.90fed053.png";